/**
 * Key Numbers 1039 — BDU Programme key content
 * Solid bar of big-number + label columns with hairline separators.
 */

export const KEY_NUMBERS_1039_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Key numbers",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_title: "100+",
    meta_description: "Live Lectures",
    meta_priority: 1,
    meta_status: true,
  },

  KEY_NUMBERS_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Bar background",
      value: "#836537",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#836537",
    },
    {
      fieldName: "title_start_color",
      label: "Number colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "description_color",
      label: "Label colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "gradient_color_4",
      label: "Separator lines",
      value: "#FFFFFF66",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF66",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Number",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 100+",
      defaultValue: "",
    },
    {
      header: "Label",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Live Lectures",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
